<template>
  <div>
    <b-card :title="title" style="height: 85%">
      <b-form-input
        v-model="filter"
        type="search"
        :placeholder="$t('global.search') + '...'"
        class="mt-4"
        @input="searchData"
      />

      <div id="sidebar-menu" class="sidebar-report">
        <ul id="side-menu" class="list-unstyled">
          <template v-for="item in menuList">
            <li v-if="item.isTitle" :key="item.id" class="mt-4 mc-general__label">
              {{ $t(item.label) }}
            </li>
            <li v-if="!item.isTitle" :key="item.id" :class="{ active: section == item.section }">
              <a href="javascript:void(0);" class="px-1" @click="changeTab(item.section)">
                <i v-if="item.icon" :class="`mc-fa ${item.icon}`"></i>
                <span>{{ $t(item.label) }}</span>
                <span class="badge rounded-pill sidebar-pill float-end mx-2">{{ item.total }}</span>
              </a>
            </li>
          </template>
        </ul>
        <ul id="side-menu" class="list-unstyled align-bottom-side-menu border-top">
          <li v-if="hasAccess(['a5a-penjadwalan-report:read'])">
            <a
              href="javascript:void(0);"
              class="px-1"
              @click="$router.push({ name: 'Report Scheduler' })"
            >
              <i class="mc-fa icon-outline_calendar"></i>
              <span>{{ $t('report.object.schedule') }}</span>
            </a>
          </li>
          <li>
            <a class="px-1" href="javascript:void(0);" @click="openModal">
              <i class="mc-fa icon-outline_file-text"></i>
              <span>{{ $t('report.title.downloadHistory') }}</span>
            </a>
          </li>
          <li v-if="hasAccess(['a5a-penjadwalan-report:read'])">
            <a
              @click="$router.push({ name: 'Report Scheduler History' })"
              href="javascript:void(0);"
              class="px-1"
            >
              <i class="mc-fa icon-outline_email"></i>
              <span>{{ $t('report.title.reportDeliveryHistory') }}</span>
            </a>
          </li>
        </ul>
      </div>
    </b-card>
    <ModalDownloadHistory ref="modalDownloadHistoryRef" />
  </div>
</template>
<script>
import ModalDownloadHistory from './ModalDownloadHistory.vue'
import { debounce } from '@/mixin/helper'
import { MixPanel } from '@/mixin/mixpanel'
import { mapGetters } from 'vuex'

export default {
  components: {
    ModalDownloadHistory,
  },
  props: {
    title: {
      type: String,
    },
    menuList:{
      type: Array,
      required: true
    }
  },
  data() {
    return {
      filter: '',
      section: 'all',
    }
  },
  mixins: [MixPanel],
  computed: {
    ...mapGetters({
      hasAccess: 'identity/hasAccess',
    }),
  },
  methods: {
    searchData: debounce(function () {
      this.onFiltered()
    }, 500),
    changeTab(section) {
      if (section === 'favorite') this.track('Favorite Reports Page')
      if (section === 'saved') this.track('Saved Reports Page')
      this.section = section
      this.$emit('reportTab', section)
    },
    onFiltered() {
      if (this.filter > 0 && this.filter < 3) return
      const filter = { search: this.filter, section: this.section }
      this.$emit('searchReport', filter)
    },
    openModal() {
      this.$refs.modalDownloadHistoryRef.toDownloadHistory()
    },
  },
}
</script>
<style scoped lang="scss">
.sidebar-pill {
  background-color: $mep-secondary-100 !important;
  color: $mep-secondary;
}

.active {
  background-color: $mep-secondary-100 !important;
  span {
    color: $mep-primary !important;
  }
  .mc-fa {
    &:before {
      color: $mep-primary !important;
    }
  }
  .sidebar-pill {
    background-color: $white !important;
    color: $mep-secondary !important;
  }
  .border-top {
    border-top: 1px solid $mep-secondary-100;
  }
}

@media only screen and (min-height: 715px) {
  .align-bottom-side-menu {
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
  }

  .sidebar-report {
    position: relative;
    height: 90%;
  }
}
</style>
